// import { NbMenuItem } from '@nebular/theme';

// export const MENU_ITEMS: NbMenuItem[] = [
//   // {
//   //   title: 'Login',
//   //   icon: 'shopping-cart-outline',
//   //   link: '/login',
//   //   home: true,
//   // },

//     // {
//     // title: 'Dashboard',
//     // icon: 'layout-outline',
//     // children: [
//     //   {
//     //     title: 'Manager-Dashboard',
//     //     icon: 'fa-male',
//     //     link: 'dashboard-manager',
//     //     home: true,
//     //   },
//     //   {
//     //     title: 'Engineer-Dashboard',
//     //     icon: 'fa-users',
//     //     link: 'dashboard-engineer',
//     //     home: true,
//     //   },
//     // ],
//     // {
//     //   title: 'Dashboard',
//     //   icon: 'layout-outline',
//     //   children: [
//         {
//           title: 'Manager-Dashboard',
//           icon: 'fa-user-circle',
//           link: 'dashboard-manager',
//           home: true,
//           children: [
//             {
//               title: 'Overview',
//               icon: 'eye-outline', // Example icon
//               link: 'dashboard-manager/overview',
//               // link: 'dashboard-manager',
//             },
//             {
//               title: 'Analysis',
//               icon: 'bar-chart-outline', // Example icon
//               link: 'dashboard-manager/analysis',
//             },
//           ],
//         },
//         {
//           title: 'Engineer-Dashboard',
//           icon: 'fa-users',
//           link: 'dashboard-engineer',
//           home: true,
//           children: [
//             {
//               title: 'Overview',
//               icon: 'eye-outline', // Example icon
//               link: 'dashboard-engineer/overview',
//               // link: 'dashboard-engineer',
//             },
//             {
//               title: 'Analysis',
//               icon: 'bar-chart-outline', // Example icon
//               link: 'dashboard-engineer/analysis',
//             },
//           ],
//         },
//         {
//           title: 'Project View',
//           icon: 'fa-user-circle',
//           link: 'project-view',
//           // home: true,
//           // children: [
//           //   {
//           //     title: 'Overview',
//           //     icon: 'eye-outline', // Example icon
//           //     link: 'dashboard-engineer/overview',
//           //     // link: 'dashboard-engineer',
//           //   },
//           //   {
//           //     title: 'Analysis',
//           //     icon: 'bar-chart-outline', // Example icon
//           //     link: 'dashboard-engineer/analysis',
//           //   },
//           // ],
//         },
//         // {
//         //   title: 'Part Info',
//         //   icon: 'eye-outline',
//         //   link: 'part-info',         
//         // },
//       // ],
//     // },
//   // {
//   //   title: 'Manager-Dashboard',
//   //   icon: 'fa-male',
//   //   link: 'dashboard-manager',
//   //   home: true,
//   // },
//   // {
//   //   title: 'Engineer-Dashboard',
//   //   icon: 'fa-users',
//   //   link: 'dashboard-engineer',
//   //   home: true,
//   // },
//   // {
//   //   title: 'E-commerce',
//   //   icon: 'shopping-cart-outline',
//   //   link: 'dashboard-manager',
//   //   home: true,
//   // },
//   // {
//   //   title: 'IoT Dashboard',
//   //   icon: 'home-outline',
//   //   link: '/pages/iot-dashboard',
//   // },
//   {
//     title: 'FEATURES',
//     group: true,
//   },
//   // {
//   //   title: 'Layout',
//   //   icon: 'layout-outline',
//   //   children: [
//   //     {
//   //       title: 'Stepper',
//   //       link: '/pages/layout/stepper',
//   //     },
//   //     {
//   //       title: 'List',
//   //       link: '/pages/layout/list',
//   //     },
//   //     {
//   //       title: 'Infinite List',
//   //       link: '/pages/layout/infinite-list',
//   //     },
//   //     {
//   //       title: 'Accordion',
//   //       link: '/pages/layout/accordion',
//   //     },
//   //     {
//   //       title: 'Tabs',
//   //       pathMatch: 'prefix',
//   //       link: '/pages/layout/tabs',
//   //     },
//   //   ],
//   // },
//   // {
//   //   title: 'Forms',
//   //   icon: 'edit-2-outline',
//   //   children: [
//   //     {
//   //       title: 'Form Inputs',
//   //       link: '/forms/inputs',
//   //     },
//   //     {
//   //       title: 'Form Layouts',
//   //       link: '/forms/layouts',
//   //     },
//   //     {
//   //       title: 'Buttons',
//   //       link: 'forms/buttons',
//   //     },
//   //     {
//   //       title: 'Datepicker',
//   //       link: '/forms/datepicker',
//   //     },
//   //   ],
//   // },
//   // {
//   //   title: 'UI Features',
//   //   icon: 'keypad-outline',
//   //   link: '/pages/ui-features',
//   //   children: [
//   //     {
//   //       title: 'Grid',
//   //       link: '/pages/ui-features/grid',
//   //     },
//   //     {
//   //       title: 'Icons',
//   //       link: '/pages/ui-features/icons',
//   //     },
//   //     {
//   //       title: 'Typography',
//   //       link: '/pages/ui-features/typography',
//   //     },
//   //     {
//   //       title: 'Animated Searches',
//   //       link: '/pages/ui-features/search-fields',
//   //     },
//   //   ],
//   // },
//   // {
//   //   title: 'Modal & Overlays',
//   //   icon: 'browser-outline',
//   //   children: [
//   //     {
//   //       title: 'Dialog',
//   //       link: '/pages/modal-overlays/dialog',
//   //     },
//   //     {
//   //       title: 'Window',
//   //       link: '/pages/modal-overlays/window',
//   //     },
//   //     {
//   //       title: 'Popover',
//   //       link: '/pages/modal-overlays/popover',
//   //     },
//   //     {
//   //       title: 'Toastr',
//   //       link: '/pages/modal-overlays/toastr',
//   //     },
//   //     {
//   //       title: 'Tooltip',
//   //       link: '/pages/modal-overlays/tooltip',
//   //     },
//   //   ],
//   // },
//   // {
//   //   title: 'Extra Components',
//   //   icon: 'message-circle-outline',
//   //   children: [
//   //     {
//   //       title: 'Calendar',
//   //       link: '/pages/extra-components/calendar',
//   //     },
//   //     {
//   //       title: 'Progress Bar',
//   //       link: '/pages/extra-components/progress-bar',
//   //     },
//   //     {
//   //       title: 'Spinner',
//   //       link: '/pages/extra-components/spinner',
//   //     },
//   //     {
//   //       title: 'Alert',
//   //       link: '/pages/extra-components/alert',
//   //     },
//   //     {
//   //       title: 'Calendar Kit',
//   //       link: '/pages/extra-components/calendar-kit',
//   //     },
//   //     {
//   //       title: 'Chat',
//   //       link: '/pages/extra-components/chat',
//   //     },
//   //   ],
//   // },
//   // {
//   //   title: 'Maps',
//   //   icon: 'map-outline',
//   //   children: [
//   //     {
//   //       title: 'Google Maps',
//   //       link: '/pages/maps/gmaps',
//   //     },
//   //     {
//   //       title: 'Leaflet Maps',
//   //       link: '/pages/maps/leaflet',
//   //     },
//   //     {
//   //       title: 'Bubble Maps',
//   //       link: '/pages/maps/bubble',
//   //     },
//   //     {
//   //       title: 'Search Maps',
//   //       link: '/pages/maps/searchmap',
//   //     },
//   //   ],
//   // },
//   // {
//   //   title: 'Charts',
//   //   icon: 'pie-chart-outline',
//   //   children: [
//   //     {
//   //       title: 'Echarts',
//   //       link: '/pages/charts/echarts',
//   //     },
//   //     {
//   //       title: 'Charts.js',
//   //       link: '/pages/charts/chartjs',
//   //     },
//   //     {
//   //       title: 'D3',
//   //       link: '/pages/charts/d3',
//   //     },
//   //   ],
//   // },
//   // {
//   //   title: 'Editors',
//   //   icon: 'text-outline',
//   //   children: [
//   //     {
//   //       title: 'TinyMCE',
//   //       link: '/pages/editors/tinymce',
//   //     },
//   //     {
//   //       title: 'CKEditor',
//   //       link: '/pages/editors/ckeditor',
//   //     },
//   //   ],
//   // },
//   // {
//   //   title: 'Tables & Data',
//   //   icon: 'grid-outline',
//   //   children: [
//   //     {
//   //       title: 'Smart Table',
//   //       link: '/pages/tables/smart-table',
//   //     },
//   //     {
//   //       title: 'Tree Grid',
//   //       link: '/pages/tables/tree-grid',
//   //     },
//   //   ],
//   // },
//   // {
//   //   title: 'Miscellaneous',
//   //   icon: 'shuffle-2-outline',
//   //   children: [
//   //     {
//   //       title: '404',
//   //       link: '/pages/miscellaneous/404',
//   //     },
//   //   ],
//   // },
//   // {
//   //   title: 'Auth',
//   //   icon: 'lock-outline',
//   //   children: [
//   //     {
//   //       title: 'Login',
//   //       link: '/auth/login',
//   //     },
//   //     {
//   //       title: 'Register',
//   //       link: '/auth/register',
//   //     },
//   //     {
//   //       title: 'Request Password',
//   //       link: '/auth/request-password',
//   //     },
//   //     {
//   //       title: 'Reset Password',
//   //       link: '/auth/reset-password',
//   //     },
//   //   ],
//   // },
//   // {
//   //   title: 'Auth',
//   //   icon: 'lock-outline',
//   //   children: [
//   //     {
//   //       title: 'Login',
//   //       link: 'login',
//   //     },
//   //     {
//   //       title: 'Register',
//   //       link: 'register',
//   //     },
//   //     {
//   //       title: 'Request Password',
//   //       link: 'request-password',
//   //     },
//   //     {
//   //       title: 'Reset Password',
//   //       link: 'reset-password',
//   //     },
//   //   ],
//   // },
// ];




// import { NbMenuItem } from '@nebular/theme';

// // Assume this value comes from a service or authentication mechanism
// // Set the user role (Manager or Engineer) dynamically
// // function getUserRole(): string | null {
// //   return sessionStorage.getItem('role');
// // }
// // // const userRole: any = ''; // Example, replace with dynamic role fetching logic
// // const userRole: any = getUserRole(); // Example, replace with dynamic role fetching logic
// // Fetch user role from session storage or service
// function getUserRole(): string | null {
//   return sessionStorage.getItem('role');
// }
// const userRole: string | null = getUserRole();

// export const MENU_ITEMS: NbMenuItem[] = [
//   // Common menu items (that are visible to all users)
//   {
//     title: 'FEATURES',
//     group: true,
//   },

//   // Conditionally render the dashboards based on user role
//   ...(userRole === 'Manager' || userRole === 'Admin'
//     ? [
//         {
//           title: 'Manager-Dashboard',
//           icon: 'fa-user-circle',
//           link: 'dashboard-manager',
//           home: true,
//           hidden: sessionStorage.getItem('role') !== 'Manager',
//           children: [
//             {
//               title: 'Overview',
//               icon: 'eye-outline',
//               link: 'dashboard-manager/overview',
//             },
//             {
//               title: 'Analysis',
//               icon: 'bar-chart-outline',
//               link: 'dashboard-manager/analysis',
//             },
//           ],
//         },
//       ]
//     : userRole === 'Engineer'
//       ? [
//         {
//           title: 'Engineer-Dashboard',
//           icon: 'fa-users',
//           link: 'dashboard-engineer',
//           home: true,
//           hidden: sessionStorage.getItem('role') !== 'Engineer',
//           children: [
//             {
//               title: 'Overview',
//               icon: 'eye-outline',
//               link: 'dashboard-engineer/overview',
//             },
//             {
//               title: 'Analysis',
//               icon: 'bar-chart-outline',
//               link: 'dashboard-engineer/analysis',
//             },
//           ],
//         },
//       ]
//       : userRole === 'Admin' ?
//         [
//           {
//             title: 'Admin Dashboard',
//             icon: 'lock-outline',
//             link: '/dashboard-manager', // Replace with admin dashboard link if different
//             hidden: sessionStorage.getItem('role') !== 'Admin',
//           },
//         ]
//         : []), 
//     // In case of no role or unknown role, render nothing for dashboards
//     {
//       title: 'Project View',
//       icon: 'fa-user-circle',
//       link: 'project-view',      
//     },
// ];




// import { NbMenuItem } from '@nebular/theme';
// import { Observable, of as observableOf } from 'rxjs';
// import { Injectable } from '@angular/core';

// // Service to dynamically fetch user roles
// @Injectable({
//   providedIn: 'root',
// })
// export class MenuService {
//   private users: any = {
//     nick: { name: '' },
//   };

//   // Function to dynamically fetch the user's role
//   getUserRole(): string | null {
//     try {
//       return sessionStorage.getItem('role'); // Fetch role from session storage
//     } catch (error) {
//       console.error('Error fetching role:', error);
//       return null; // Fallback if role cannot be retrieved
//     }
//   }

//   // Function to get the menu items based on the user's role
//   getMenuItems(): Observable<NbMenuItem[]> {
//     const userRole = this.getUserRole(); // Fetch the role dynamically

//     this.users.nick.name = userRole || 'Guest'; // Set the user role or default to 'Guest'

//     // Define the menu items dynamically based on role
//     const MENU_ITEMS: NbMenuItem[] = [
//       // Common menu items for all users
//       {
//         title: 'FEATURES',
//         group: true,
//       },
//       ...(userRole === 'Manager' || userRole === 'Admin'
//         ? [
//             {
//               title: 'Manager-Dashboard',
//               icon: 'fa-user-circle',
//               link: 'dashboard-manager',
//               home: true,
//               hidden: sessionStorage.getItem('role') !== 'Manager',
//               children: [
//                 {
//                   title: 'Overview',
//                   icon: 'eye-outline',
//                   link: 'dashboard-manager/overview',
//                 },
//                 {
//                   title: 'Analysis',
//                   icon: 'bar-chart-outline',
//                   link: 'dashboard-manager/analysis',
//                 },
//               ],
//             },
//           ]
//         : userRole === 'Engineer'
//         ? [
//             {
//               title: 'Engineer-Dashboard',
//               icon: 'fa-users',
//               link: 'dashboard-engineer',
//               home: true,
//               hidden: sessionStorage.getItem('role') !== 'Engineer',
//               children: [
//                 {
//                   title: 'Overview',
//                   icon: 'eye-outline',
//                   link: 'dashboard-engineer/overview',
//                 },
//                 {
//                   title: 'Analysis',
//                   icon: 'bar-chart-outline',
//                   link: 'dashboard-engineer/analysis',
//                 },
//               ],
//             },
//           ]
//         : userRole === 'Admin'
//         ? [
//             {
//               title: 'Admin Dashboard',
//               icon: 'lock-outline',
//               link: '/dashboard-manager', // Replace with admin dashboard link if different
//               hidden: sessionStorage.getItem('role') !== 'Admin',
//             },
//           ]
//         : []),
//       // Fallback menu item if no valid role is found
//       {
//         title: 'Project View',
//         icon: 'fa-user-circle',
//         link: 'project-view',
//       },
//     ];

//     // Return the menu items as an observable
//     return observableOf(MENU_ITEMS);
//   }
// }
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { NbMenuItem } from '@nebular/theme';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private roleSubject = new BehaviorSubject<string | null>(null);

  constructor() {
    // Initialize with the current role from sessionStorage
    const role = this.getUserRole();
    this.roleSubject.next(role);
  }

  // Fetch role from sessionStorage
  private getUserRole(): string | null {
    return sessionStorage.getItem('role');
  }

  // Update the role and notify subscribers
  setRole(role: string): void {
    sessionStorage.setItem('role', role);
    this.roleSubject.next(role);
  }

  // Observable for the role
  getRole(): Observable<string | null> {
    return this.roleSubject.asObservable();
  }

  // Fetch menu items based on role
  getMenuItems(): Observable<NbMenuItem[]> {
    const role: any = this.getUserRole();
    const isTechEngineer = role && role.toString().toLowerCase().includes('tech');

    const menuItems: any //NbMenuItem[] 
      = [
        // { title: 'FEATURES', group: true },
        // { title: role === 'Manager' ? 'Manager' : 'Engineer', group: true },
        {
          title: ['Manager', 'Admin', 'Engineer'].includes(role)
            ? role
            : isTechEngineer
              ? 'Technical Engineer'
              : 'Engineer',
          group: true
        },
        ...(role === 'Manager'
          ? [
            {
              // title: 'Manager-Dashboard',
              title: 'Dashboard',
              icon: 'person-outline',
              link: 'dashboard-manager',
              children: [
                 { title: 'Overview',  icon: 'monitor-outline', link: 'dashboard-manager' },
                // { title: 'Overview', icon: 'eye-outline', link: 'dashboard-manager/overview' },
                { title: 'Source Pulse', icon: 'bar-chart-outline', link: 'dashboard-manager/analysis' },
              ],
            },
          ]
          : role === 'Engineer'
            ? [
              {
                // title: 'Engineer-Dashboard',
                title: 'Dashboard',
                icon: 'people-outline',
                link: 'dashboard-engineer',
                children: [
                  { title: 'Overview', icon: 'monitor-outline', link: 'dashboard-engineer' },
                  // { title: 'Overview', icon: 'eye-outline', link: 'dashboard-engineer/overview' },
                  { title: 'Source Pulse', icon: 'bar-chart-outline', link: 'dashboard-engineer/source-pulse' },
                ],
              },
            ]
            : role === 'Admin'
              ? [
                {
                  // title: 'Manager-Dashboard',
                  title: 'Dashboard',
                  icon: 'person-outline',
                  link: 'dashboard-admin',
                  // children: [
                  //   { title: 'Overview', icon: 'eye-outline', link: 'dashboard-admin/overview' },
                  //   { title: 'Analysis', icon: 'bar-chart-outline', link: 'dashboard-admin/analysis' },
                  // ],
                },
              ]
              : isTechEngineer
                ? [
                  {
                    title: 'Technical Dashboard',
                    icon: 'cube-outline',
                    link: 'technical-engineer-dashboard',
                    home: true,
                  },
                ]
                : []),
        {
          title: 'Technical Dashboard',
          icon: 'cube-outline',
          link: 'technical-engineer-dashboard',
          hidden: isTechEngineer || !['Manager', 'Admin'].includes(role)
        },
        {
          title: 'Project View', icon: 'briefcase-outline', link: 'project-view',
          hidden: !(role === 'Manager' || role === 'Engineer')
        },
        {
          title: 'Smart Sync', icon: 'sync-outline', link: 'smart-sync',
          hidden: !(role === 'Manager' || role === 'Engineer')
        },
        {
          title: 'Part Alert', icon: 'alert-triangle-outline', link: 'part-alert',
          hidden: !(role === 'Manager' || role === 'Engineer')
        },
        // {
        //   title: 'Master Data', icon: 'bar-chart-outline', link: 'master-data',
        //   hidden: !(role === 'Manager' || role === 'Engineer')
        // },
        // { title: 'Project View', icon: 'briefcase-outline', link: 'project-view' },
        // { title: 'Smart Sync', icon: 'sync-outline', link: 'smart-sync' },
        // { title: 'Part Alert', icon: 'alert-triangle-outline', link: 'part-alert' },

        {
          title: 'Master Data', icon: 'bar-chart-outline', link: 'master-data',
          hidden: !(role === 'Manager' || role === 'Engineer'),
          children: [
            { title: 'Duty Matrix', icon: 'grid-outline', link: 'master-data/dutyMatrix' },
            { title: 'Freight Matrix', icon: 'cube-outline', link: 'master-data/freightMatrix' },
            { title: 'Users', icon: 'people-outline', link: 'master-data/users' },
            { title: 'Customers', icon: 'person-done-outline', link: 'master-data/customers' },
            { title: 'Currency Conversion', icon: 'swap-outline', link: 'master-data/currencyConversion' },
            { title: 'Consolidation', icon: 'layers-outline', link: 'master-data/consolidation' },
            { title: 'PO Data', icon: 'clipboard-outline', link: 'master-data/poData' },
            { title: 'Vendor master Data', icon: 'folder-outline', link: 'master-data/vendorData' },
            { title: 'Mail Template', icon: 'file-text-outline', link: 'master-data/mailTemplate' },
          ],


        },

      ];

    return of(menuItems);
  }
}



